/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import styled, { css } from 'styled-components/macro';

const commonCss = css<{ size: string; color?: string }>`
  background-color: transparent;
  border-style: none;
  border-radius: 50%;

  min-width: ${(props) => props.size};
  width: ${(props) => props.size};
  height: ${(props) => props.size};
  min-height: ${(props) => props.size};

  color: ${(props) =>
    props.color ? props.color : 'var(--color-gravity-gray)'};

  padding: 0px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const SVGIcon = styled.div<{ size: string; color?: string }>`
  ${commonCss}
`;

// Useful component to turn material UI icons into buttons with a given
// size
const SVGIconButton = styled.button<{
  size: string;
  color?: string;
  disabled?: boolean;
}>`
  ${commonCss}

  &:hover {
    ${(props) =>
      props.disabled === undefined || props.disabled === false
        ? 'cursor:pointer;'
        : ''}
  }

  &:focus {
    outline: none;
  }
`;

export { SVGIconButton, SVGIcon };
